import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WellSkyWeeklyDashboardFixture } from '@apps/web/components/admin/wellsky_weekly_dashboard_fixture';
import { Badge } from '@apps/web/components/ui/badge';
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@apps/web/components/ui/card';

export const Route = createFileRoute(
    '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId',
)({
    component: FakeEhrRecordPage,
    validateSearch: z.object({
        fixture: z.string().optional(),
    }),
    head: () => ({
        meta: [{ title: 'Fake EHR Record | Phoebe Admin' }],
    }),
});

function FakeEhrRecordPage() {
    const { provider, entity, externalId } = Route.useParams();
    const { fixture } = Route.useSearch();

    if (
        provider === 'wellsky' &&
        entity === 'shifts' &&
        fixture === 'weekly-dashboard-open-shift'
    ) {
        return <WellSkyWeeklyDashboardFixture shiftId={externalId} />;
    }

    return (
        <div className="bg-muted/20 min-h-screen p-6">
            <div className="mx-auto w-full max-w-3xl space-y-4">
                <Badge variant="secondary">Extension Lab / Fake EHR</Badge>
                <Card>
                    <CardHeader>
                        <CardTitle className="text-2xl font-semibold">
                            {entity.slice(0, 1).toUpperCase() + entity.slice(1)}{' '}
                            {externalId}
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3 text-sm">
                        <div className="grid grid-cols-[140px_1fr] gap-2">
                            <span className="text-muted-foreground">
                                Provider
                            </span>
                            <span className="font-medium">{provider}</span>
                        </div>
                        <div className="grid grid-cols-[140px_1fr] gap-2">
                            <span className="text-muted-foreground">
                                Object Type
                            </span>
                            <span className="font-medium">{entity}</span>
                        </div>
                        <div className="grid grid-cols-[140px_1fr] gap-2">
                            <span className="text-muted-foreground">
                                External ID
                            </span>
                            <span className="font-medium">{externalId}</span>
                        </div>
                        <div className="grid grid-cols-[140px_1fr] gap-2">
                            <span className="text-muted-foreground">
                                Status
                            </span>
                            <span className="font-medium">
                                Draft (simulated)
                            </span>
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader>
                        <CardTitle>Simulator Controls</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-2 text-sm">
                        <a
                            href={`/admin/extension-lab/ehr/${provider}/${entity}/${externalId}-alt`}
                            className="hover:bg-muted block rounded-md border px-3 py-2 transition-colors"
                        >
                            Open alternate ID variant
                        </a>
                        <a
                            href="/admin/extension-lab"
                            className="hover:bg-muted block rounded-md border px-3 py-2 transition-colors"
                        >
                            Back to extension lab home
                        </a>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
